"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../../../../constant");
var _ = require("../../..");
var _styled = require("../../../base/styled");
var _utils = require("../../../../utils");
var _instagram = _interopRequireDefault(require("../../../../assets/svg/instagram.svg"));
var _facebook = _interopRequireDefault(require("../../../../assets/svg/facebook.svg"));
var _linkedin = _interopRequireDefault(require("../../../../assets/svg/linkedin.svg"));
var _twitter = _interopRequireDefault(require("../../../../assets/svg/twitter.svg"));
var _youtube = _interopRequireDefault(require("../../../../assets/png/youtube.png"));
var _styled2 = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AboutUsSection = function AboutUsSection(_ref) {
  var company = _ref.company,
    open = _ref.open,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    showValidateIcon = _ref.showValidateIcon,
    getName = _ref.getName,
    numberOfEmployeesOptions = _ref.numberOfEmployeesOptions;
  return /*#__PURE__*/_react.default.createElement(_.Collapsible, {
    id: _constant.companySection.ABOUT_US,
    onCollapse: onCollapse,
    title: "About Us",
    open: open.aboutUs,
    isValid: isValid,
    showValidateIcon: showValidateIcon
  }, company.alias && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Employer Alias"), /*#__PURE__*/_react.default.createElement(_styled.Text, null, company.alias)), /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Company Description (Preview)"), /*#__PURE__*/_react.default.createElement(_styled.Text, null, company.overallShortStatement)), /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Company Description"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.description)), company.additionalLocations[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Additional Locations"), company.additionalLocations.map(function (location, index) {
    var _location$country, _location$country2, _location$country3, _location$state, _location$city;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      style: {
        marginBottom: '20px'
      }
    }, /*#__PURE__*/_react.default.createElement(_styled.Text, null, location.international ? 'International' : 'US'), location.international && /*#__PURE__*/_react.default.createElement(_styled.Text, null, "Country: ", (_location$country = location.country) === null || _location$country === void 0 ? void 0 : _location$country.country), location.international && ((_location$country2 = location.country) === null || _location$country2 === void 0 ? void 0 : _location$country2.id) === 214 && /*#__PURE__*/_react.default.createElement(_styled.Text, null, "Country name: ", location.countryName), location.international && ((_location$country3 = location.country) === null || _location$country3 === void 0 ? void 0 : _location$country3.id) !== 214 && location.cityName && /*#__PURE__*/_react.default.createElement(_styled.Text, null, "City: ", location.cityName), !location.international && /*#__PURE__*/_react.default.createElement(_styled.Text, null, "State: ", (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.name), !location.international && /*#__PURE__*/_react.default.createElement(_styled.Text, null, "City: ", (_location$city = location.city) === null || _location$city === void 0 ? void 0 : _location$city.city));
  })), /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Company Website"), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    $bsStyle: {
      marginTop: '0px',
      marginBottom: '0px'
    },
    href: company.urlAddress,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _utils.getUrlWithoutProtocol)(company.urlAddress))), company.numberOfEmployees && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Number of Employees"), /*#__PURE__*/_react.default.createElement(_styled.Text, null, getName(company.numberOfEmployees, numberOfEmployeesOptions))), company.jobFunctions[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Internship and Job Functions"), company.jobFunctions.map(function (jobFunction) {
    return /*#__PURE__*/_react.default.createElement(_styled.Text, {
      key: jobFunction.id
    }, jobFunction.name);
  })), company.internalDivisions[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Internal Divisions"), company.internalDivisions.map(function (internalDivision) {
    var _internalDivision$ind;
    return /*#__PURE__*/_react.default.createElement(_styled.Column, {
      key: internalDivision.id,
      $bsStyle: {
        marginBottom: '24px'
      }
    }, /*#__PURE__*/_react.default.createElement(_styled.Text, null, internalDivision.title), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
      href: internalDivision.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, (0, _utils.getUrlWithoutProtocol)(internalDivision.url)), /*#__PURE__*/_react.default.createElement(_styled.Text, null, (_internalDivision$ind = internalDivision.industry) === null || _internalDivision$ind === void 0 ? void 0 : _internalDivision$ind.name));
  })), company.subsidiaries[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Subsidiaries"), company.subsidiaries.map(function (subsidiary, index) {
    var _subsidiary$industry, _subsidiary$verticalI;
    return /*#__PURE__*/_react.default.createElement(_styled.Column, {
      key: index,
      $bsStyle: {
        marginBottom: '24px'
      }
    }, /*#__PURE__*/_react.default.createElement(_styled.Text, null, subsidiary.title), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
      href: subsidiary.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, (0, _utils.getUrlWithoutProtocol)(subsidiary.url)), /*#__PURE__*/_react.default.createElement(_styled.Text, null, (_subsidiary$industry = subsidiary.industry) === null || _subsidiary$industry === void 0 ? void 0 : _subsidiary$industry.name), /*#__PURE__*/_react.default.createElement(_styled.Text, null, (_subsidiary$verticalI = subsidiary.verticalIndustry) === null || _subsidiary$verticalI === void 0 ? void 0 : _subsidiary$verticalI.name));
  })), company.socialMedias[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Social Media"), /*#__PURE__*/_react.default.createElement(_styled.Row, {
    $bsStyle: {
      flexWrap: 'wrap'
    }
  }, company.socialMedias.map(function (media, index) {
    return /*#__PURE__*/_react.default.createElement("a", {
      key: index,
      href: media.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, media.social === _constant.socialMedia.FACEBOOK && /*#__PURE__*/_react.default.createElement("img", {
      src: _facebook.default,
      alt: "facebook",
      style: {
        width: '32px'
      }
    }), media.social === _constant.socialMedia.INSTAGRAM && /*#__PURE__*/_react.default.createElement("img", {
      src: _instagram.default,
      alt: "instagram",
      style: {
        width: '32px'
      }
    }), media.social === _constant.socialMedia.LINKEDIN && /*#__PURE__*/_react.default.createElement("img", {
      src: _linkedin.default,
      alt: "linkedin",
      style: {
        width: '32px'
      }
    }), media.social === _constant.socialMedia.TWITTER && /*#__PURE__*/_react.default.createElement("img", {
      src: _twitter.default,
      alt: "twitter",
      style: {
        width: '32px'
      }
    }), media.social === _constant.socialMedia.YOUTUBE && /*#__PURE__*/_react.default.createElement("img", {
      src: _youtube.default,
      alt: "youtube",
      style: {
        width: '32px',
        marginTop: '5px',
        marginLeft: '5px'
      }
    }));
  }))));
};
AboutUsSection.propTypes = {
  company: _utils.companyProps.isRequired,
  open: _utils.opportunitySectionsProps.isRequired,
  onCollapse: _propTypes.default.func.isRequired,
  getName: _propTypes.default.func.isRequired,
  isValid: _propTypes.default.bool.isRequired,
  numberOfEmployeesOptions: _utils.employeesProps,
  showValidateIcon: _propTypes.default.bool
};
AboutUsSection.defaultProps = {
  showValidateIcon: false,
  numberOfEmployeesOptions: []
};
var _default = AboutUsSection;
exports.default = _default;